import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'redux/rootReducer';
import { loadOwnerTypes } from 'redux/reducers/ownerTypes';

import getFilteredOwnerTypes from '../util/getFilteredOwnerTypes';

import Dropdown from 'components/base/Dropdown/Dropdown';

import { DropdownWrapper } from '../styles/Playlist.styles';

interface IOwnerTypesDropdownProps {
  setOwnerType?: any;
  selectedOwnerType?: any;
  isSmallScreen?: boolean;
}

export const allOwnerType = { label: 'All Owner Types', ownerTypeId: 0 };

const itemToString = (item: any): any => item.ownerTypeId;

const OwnerTypesDropdown: React.FC<IOwnerTypesDropdownProps> = (props) => {
  const { setOwnerType, isSmallScreen, selectedOwnerType } = props;

  const dispatch = useDispatch();

  const ownerTypes = [
    allOwnerType,
    ...useSelector((state: RootState) => state.ownerTypes.data).map((d) => ({
      ...d,
      label: d.ownerType,
    })),
  ];

  const ownerTypeIds = ownerTypes.map((oType) => oType.ownerTypeId);
  const filterdOwnerTypes = getFilteredOwnerTypes(ownerTypeIds);

  useEffect(() => {
    dispatch(loadOwnerTypes());
  }, [dispatch]);

  return (
    <DropdownWrapper isSmallScreen={isSmallScreen}>
      <Dropdown
        onChange={(item: any): void => {
          setOwnerType(item);
        }}
        itemToString={itemToString}
        items={filterdOwnerTypes}
        selectedItem={selectedOwnerType}
        isRoundedDropdown="all"
      />
    </DropdownWrapper>
  );
};

export default OwnerTypesDropdown;
